export default {
  name: 'notFound',
  computed: {},
  methods: {}
}



// WEBPACK FOOTER //
// ./src/components/404/404.js